export default __webpack_public_path__ + "static/fertilesummerbackground-6763d539e06ca7e429d9e227083463d9.jpg";